export default __webpack_public_path__ + "static/media/vedansh_shrivastava.ab86cf4e.jpg";